<template>
  <fragment>
    <tr v-if="canDispalayPromotionalPackage">
      <td scope="row" class="productForm__itemName">
        <label class="checkbox-inline" v-if="!isCoupon">
          <input type="checkbox" :name="confectionItem.slug" :id="confectionItem.slug" v-model="isItemSelected">
        </label>
        <!-- <img class="d-none" :src="confectionItemImageUrl" :alt="confectionItem.name"> -->
        <div>
          <label :for="confectionItem.idproducts" class="mr-2">{{ confectionItem.name }}</label>
          <span class="price-per-item">{{ parseFloat(inputCharge).toFixed(2) }} zł / sztuka</span>
          <span><promo-packet-modal v-if="hasModal()"></promo-packet-modal></span>
        </div>
        <a href="#" class="confectionRow__link" @click.prevent="handleModalOpen"><Icon v-tooltip="tooltipMessage" icon="info" /></a>
      </td>
      <td class="productForm__itemValue" :data-label="isCoupon ? 'Liczba': null">
            <ValidationProvider
              :rules="`confectionMaxBaseOnProducts:${totalProductsQuantityOnDeliveryPoint}`"
              v-slot="{ errors, classes }"
            >
              <InputSpinners
                @increase="handleIncreaseQuantity"
                @decrease="handleDecreaseQuantity"
                :class="isCoupon ? '' : 'd-none'"
              >
                <input
                  type="number"
                  :min="0"
                  name="productQuantity"
                  class="form-control"
                  :class="classes"
                  v-model.number="inputQuantity"
                  :readonly="!isCoupon"
                  onfocus="this.select();"
                  @input="handleChange($event)"
                  @wheel="$event.target.blur()"
                  ref="productQuantityRef"
                >
              </InputSpinners>
              <span class="text-danger error-message" v-for="(error, index) in errors" :key="index">{{ error }}</span>
            </ValidationProvider>
      </td>
      <td class="productForm__itemPrice" data-label="Suma">
        <span v-if="confectionItem.product_category !== 'AD' && confectionItem.product_category !== 'MRK'">{{(inputQuantity * inputCharge).toFixed(2) }} zł</span>
      </td>
    </tr>
    <confection-modal @handleModalOpen="handleModalOpen" :file-name="getFileName" :is-open="isConfectionModalOpen" :modal-type="getModalType" />
  </fragment>
</template>

<script>
import _ from 'lodash';
import { confectionModalMixin } from '../Modals/confectionModalMixin';
import ConfectionModal from '../Modals/ConfectionModal.vue';
import PromoPacketModal from '../Modals/PromoPacketModal.vue';
import { modalType as modalDefinedTypes } from '../Modals/modalType';
import { getProductType } from '../Modals/modalMapper';
import Icon from '../Icon.vue';
import InputSpinners from '../Inputs/InputSpinners.vue';
import {
  filterOutConfectionProduct,
  filterProductsForDeliveryNumber,
} from '../../utils/confection/filters';
import { checkProductsIsCoupon } from '@/utils/categoryUtils';
import { DataLayerManager } from '@/utils/DataLayerManager';
import { confectionTooltips } from '@/utils/confection/tooltips';

const slugToModalType = {
  'ozdobne-swiateczne-etui-na-karte': modalDefinedTypes.NDE_ETUI_CARD_CHRISTMAS,
};

export default {
  name: 'ConfectionRowForm',
  mixins: [confectionModalMixin],
  components: {
    PromoPacketModal,
    ConfectionModal,
    Icon,
    InputSpinners,
  },
  props: ['confectionItem', 'delivery_id'],
  data() {
    return {
      inputQuantity: 0,
      inputCharge: 0,
      lastQuantity: 0,
      isItemSelected: false,
    };
  },
  created() {
    const product = this.populateValue();
    this.inputQuantity = (product.length > 0) ? product[0].quantity : 0;
    this.lastQuantity = this.inputQuantity;
    this.inputCharge = this.confectionItem.price || 0;
    this.isItemSelected = !!this.inputQuantity;
  },
  computed: {
    isCoupon() {
      return checkProductsIsCoupon(this.$store.state.products.all.products[0]);
    },
    getDisabled() {
      return this.confectionItem.idproducts === 1000002 && this.$store.getters['cart/getUserIsGuest'];
    },
    confectionItemImageUrl() {
      return `${process.env.VUE_APP_BASE_URL}/img/PLUXEE_confection.svg`;
    },
    canDispalayPromotionalPackage() {
      // TODO: copy to glopal config

      // Karta dla Dzieci
      if (this.$store.getters.allProducts[0].idproducts === 28898 && this.confectionItem.idproducts === 1000001) {
        return false;
      }

      const promoPacketsProduct = [26, 2, 25, 1];
      const type = this.$store.getters.getType;
      if (this.confectionItem.idproducts || this.confectionItem.id !== 1000001) {
        return true;
      }

      if (promoPacketsProduct.indexOf(parseInt(type, 10)) >= 0) {
        return true;
      }
      return false;
    },
    totalProductsQuantityOnDeliveryPoint() {
      const { productsWithoutConfection } = filterOutConfectionProduct(this.$store.state.delivery.products);
      const productsWithoutDeliveryAddress = productsWithoutConfection.filter(product => product.id !== 1000002);
      const filteredOutPromoPack = productsWithoutDeliveryAddress.filter(product => product.id !== 1000001);
      const productsForDeliveryNumber = filterProductsForDeliveryNumber(filteredOutPromoPack, this.delivery_id);

      if (productsForDeliveryNumber.length > 1) {
        return _.sumBy(productsForDeliveryNumber, product => product.quantity);
      }

      if (productsForDeliveryNumber.length === 1) {
        return productsForDeliveryNumber[0].quantity;
      }
      return 0;
    },
    getProduct() {
      let result = null;
      this.$store.state.products.all.products[0].confection.forEach((item) => {
        if (item.idproducts === this.confectionItem.idproducts) {
          result = item;
        }
      });
      return result;
    },
    getModalType() {
      const modalTypeBySlug = slugToModalType[this.confectionItem.slug];
      if (modalTypeBySlug) return modalTypeBySlug;

      const modalType = getProductType(this.$store.state.products.all.products[0].product_category);
      const normalizedItemName = this.confectionItem.name.toLowerCase();
      const confectionName = (normalizedItemName.includes('koperta') || normalizedItemName.includes('koperty')) ? 'koperta' : 'etui';
      const combinedData = `${modalType}-${confectionName}`;

      switch (combinedData) {
        case 'card-etui': return modalDefinedTypes.NDE_ETUI_CARD;
        case 'card-koperta': return modalDefinedTypes.ENVELOPE_CARD;
        case 'coupon-etui': return modalDefinedTypes.ETUI_COUPON;
        case 'coupon-koperta': return modalDefinedTypes.ENVELOPE_COUPON;
        default: {
          // eslint-disable-next-line no-console
          console.warn('combinedData() -> returned default modal');
          return modalDefinedTypes.DEFAULT;
        }
      }
    },
    getFileName() {
      const filesName = {
        EC_ISS: 'Zalacznik_do_konfekcji_kart–wzor.xlsx',
        V_ISS: 'Zalacznik_do_konfekcji_kuponow–wzor.xlsx',
      };
      const productCategory = this.$store.state.products.all.products[0].product_category;

      if (filesName[productCategory]) {
        return filesName[productCategory];
      }
      return 'Zalacznik_do_konfekcji_kart–wzor.xlsx';
    },
    tooltipMessage() {
      return confectionTooltips[this.confectionItem.slug] || '';
    },
    currentStep() {
      return this.$store.state.steps.currentStep;
    },
  },
  methods: {
    handleIncreaseQuantity() {
      this.updateInputQuantity(this.inputQuantity + 1);
    },
    handleDecreaseQuantity() {
      this.updateInputQuantity(this.inputQuantity - 1);
    },
    updateInputQuantity(quantity) {
      const min = parseInt(this.$refs.productQuantityRef.min, 10);
      if (quantity < min) return;
      const event = new Event('input', { bubbles: true });
      event.value = quantity;
      this.$refs.productQuantityRef.value = event.value;
      this.$refs.productQuantityRef.dispatchEvent(event);
    },
    handleChange(e) {
      let quantity = e.target.name === 'productQuantity' ? e.target.value : this.inputQuantity;
      if (quantity === '') {
        quantity = 0;
        this.inputQuantity = 0;
      }
      const newProduct = {
        id: this.confectionItem.idproducts,
        quantity: parseFloat(quantity),
        price: parseFloat(this.inputCharge),
        name: this.confectionItem.name,
        iddelivery: parseFloat(this.$props.delivery_id),
        product_category: this.confectionItem.product_category,
        analyticsData: this.confectionItem.analyticsData,
      };
      this.$store.dispatch('delivery/addProductToCart', newProduct);

      if (this.lastQuantity > this.inputQuantity) {
        const quantityDiff = this.lastQuantity - this.inputQuantity;
        DataLayerManager.pushRemoveCartEvent(newProduct, quantityDiff);
      } else if (this.lastQuantity < this.inputQuantity) {
        const quantityDiff = this.inputQuantity - this.lastQuantity;
        DataLayerManager.pushAddToCartEvent(newProduct, quantityDiff);
      }

      this.lastQuantity = this.inputQuantity;
    },
    removeItem() {
      const removedProduct = this.getProductFromDelivery();
      this.$store.dispatch('delivery/deleteProductFromCart', [this.product, this.$props.delivery_id]);
      DataLayerManager.pushRemoveCartEvent(this.product, removedProduct[0].quantity);
    },
    getProductFromDelivery() {
      return this.$store.getters['delivery/getValue'](Number(this.$props.delivery_id), this.product.idproducts);
    },
    populateValue() {
      return this.$store.getters['delivery/getValue'](Number(this.delivery_id), this.confectionItem.idproducts);
    },
    hasModal() {
      return this.confectionItem.product_category === 'MRK';
    },
    setQuantity(quantity) {
      this.inputQuantity = quantity;
      this.handleChange({
        target: {
          name: 'productQuantity',
          value: quantity,
        },
      });
    },
  },
  watch: {
    totalProductsQuantityOnDeliveryPoint(val) {
      if (!this.isItemSelected || this.isCoupon) return;
      this.setQuantity(val);
    },
    isItemSelected(val) {
      if (this.isCoupon) return;

      if (!val) {
        this.setQuantity(0);
      } else {
        this.setQuantity(this.totalProductsQuantityOnDeliveryPoint);
      }
    },
    inputQuantity(val) {
      if (!this.isCoupon) return;

      this.isItemSelected = val > 0;
    },
  },
};
</script>

<style scoped>
.confectionRow__link {
  cursor: pointer;
}
</style>
